<form [formGroup]="assistantForm">
    <div class="container">
        <h1 class="mb-3">Choose your AI personality</h1>
        <div class="row">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Ai Model</mat-label>
                <p></p>
                <mat-select formControlName="llmStyle" >
                    <mat-option *ngFor="let style of modelStyle" [value]="style"  class="mx-auto" >
                        {{style}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>
</form>